module.exports = __webpack_public_path__ + "img/团侧.93df8628.jpg";